Ply.AllocationWizardProductDetails = function(el, options) {
  this.dom = {
    el: el,
    button: el.querySelector("[data-product-button]"),
    modal: el.querySelector("[data-product-modal]"),
    close: el.querySelector("[data-product-modal-close]"),
    select: document.querySelectorAll("[data-product-qty-selector]"),
    
  };
  this.options = options;

  this.handleTitleClick = this.handleTitleClick.bind(this);
  this.checkForQuantities = this.checkForQuantities.bind(this);

  this.modal = UIkit.modal(this.dom.modal, { duration: 1000 });
  this.close = UIkit.close(this.dom.close);

  this.dom.el.addEventListener('click', this.handleTitleClick);
  setTimeout(function(){
    document.querySelectorAll("[data-product-qty-selector]").forEach(function(el) {
      el.addEventListener('change', function(e){
        Ply.AllocationWizardProductDetails.prototype.checkForQuantities(e);
      })
      var event = document.createEvent('HTMLEvents');
		event.initEvent('change', true, false);
		el.dispatchEvent(event);
    })}
    //
    // this.dom.select.forEach(function(el){
    //   console.log("adding change listener to: ", el)
    //   el.addEventListener('change', this.checkForQuantities);
    // })
  , 1000);

};

Ply.AllocationWizardProductDetails.prototype.handleTitleClick = function() {
  this.modal.show();
};

/* New below */
Ply.AllocationWizardProductDetails.prototype.checkForQuantities = function(e, element) {
  console.log("Event is: ", e);
  var card = element ? e.closest("[data-card-top]") : e.target.closest("[data-card-top]");
  var cardButton = card.querySelector(".allocation-checkout");
  var nextElement = cardButton.nextElementSibling;
  console.log("next element", nextElement)
  var min = card.getAttribute("data-card-min");
  var max = card.getAttribute("data-card-max");
  var quantity = 0;
  var selects = card.querySelectorAll("select");
  if(selects.length > 0){
    selects.forEach(function(element){
      quantity += parseInt(element.value);
    });
  }
  var isDisabled = !(quantity >= min && quantity <= max)
  cardButton.disabled = isDisabled
  cardButton.classList.remove("Button--primary");
  cardButton.classList.remove("Button--secondary");
  cardButton.classList.add(isDisabled ? "Button--secondary" : "Button--primary");
  var minimumQuantityNotice = card.querySelector(".minimum-quantity-notice");
  minimumQuantityNotice.style.visibility = isDisabled ? 'visible' : 'hidden';
  nextElement.style.visibility = isDisabled ? 'visible' : 'hidden';
//   If quantity is
};
